import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import Dialog from "@fluentui/react/lib/Dialog";
import { ResourceStrings } from "../../ResourceStrings";
import Button from '../shared/Button'
import Flex from "../shared/Flex";
import JsonEditor, { ValidationSchema } from "./JsonEditor";
import { Fetchable } from "../../store/appState";
import Status from "./Status";

export interface StatusDialogProps {
    loading: string;
    ok: string;
    error: string;
    data: Fetchable<any>;
    hidden: boolean;
    onClose: () => void;
}

export default function StatusDialog(props: StatusDialogProps): JSX.Element {
    return <DialogWrapper
        hidden={props.hidden}
        dialogContentProps={{
            showCloseButton: true,
            closeButtonAriaLabel: ResourceStrings.close(),
        }}
    >
        <div>
            <div className="title-instruction semibold vertical-space">Information</div>
            <Status data={props.data} loading={props.loading} ok={props.ok} error={props.error} />

            <div className="btn-container">
                <Button buttonType="normal" className="small-space" onClick={props.onClose}>Close</Button>
            </div>

        </div>
    </DialogWrapper>
}

const DialogWrapper = styled(Dialog)`
    .ms-Dialog-main {
        min-width: 20%;
        max-width: 100%;
    }

    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
    border-radius: .5em;
    padding: 2em;
    margin: 1em 0;
`;
